export default "__VITE_PUBLIC_ASSET__eecf61ee__"